import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function ConfirmationDeleteAccount({ show, onHide, onDelete, type }) {
  const actionLabel = type === "user" ? "Block" : "Delete";
  const entityLabel = type === "user" ? "user" : type === "service" ? "service" : "job";

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      className="qx-modal"
      dialogClassName="qx-modal-dialog"
      container={typeof document !== "undefined" ? document.body : undefined}
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm {actionLabel}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">
          Are you sure you want to {actionLabel.toLowerCase()} this {entityLabel}?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button className="btn-primary qx-btn-brand" onClick={onDelete}>
          {actionLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
